import React from "react";
import ReactGA from "react-ga";
import styles from "../../styles/presentational/categoryNavigation.css";

export class CategoryNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <nav className={styles.main}>
        <div className={styles.categories}>
          {this.props.categories.map((category, index) => {
            return (
              <div
                key={index}
                className={
                  styles.category +
                  (this.props.categories.length - 1 == index
                    ? " " + styles.last
                    : "")
                }
                onClick={() => {
                  ReactGA.event({
                    category: "User Action",
                    action: "Clicked Category " + category.title,
                    label: "/Spend/Presentational/CategoryNavigation",
                  });
                  this.props.onSelectCategory(category);
                }}
              >
                {this.props.selectedCategory &&
                this.props.selectedCategory.id == category.id ? (
                  <div className={styles.selected}>{category.title}</div>
                ) : (
                  category.title
                )}
              </div>
            );
          })}
        </div>
        <div
          className={styles.search}
          onClick={() => {
            ReactGA.event({
              category: "User Action",
              action: "Clicked Search All",
              label: "/Spend/Presentational/CategoryNavigation",
            });
            this.props.onSearchAll();
          }}
        >
          {this.props.dictionary.category_selector_search_all}
        </div>
      </nav>
    );
  }
}
